export const TENANT_VIEWS = {
    tenant: 'tenant',
    userDetails: 'userDetails',
    newSubtenant: 'newSubtenant',
    IPRestrictionDetails: 'IPRestrictionDetails',
} as const;

export const TENANT_NAME_PREFIX = '@';
export const SUBTENANT_PARENT_NAME_SEPARATOR = '+';
